<template>
  <div class="salesman-container">
    <!-- 搜索和添加区域 -->
    <div class="operation-area">
      <el-input
        placeholder="请输入手机号搜索"
        v-model="searchPhone"
        class="search-input"
        clearable
        @clear="handleSearch"
      >
        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
      </el-input>
      <el-button type="primary" @click="handleAdd">添加业务员</el-button>
    </div>

    <!-- 表格区域 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间">
        <template slot-scope="scope">
          {{ formatTime(scope.row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加对话框 -->
    <el-dialog title="添加业务员" :visible.sync="dialogVisible" width="50%">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { querySalesman, addSalesman, deleteSalesman } from '@/api/config';

export default {
  name: 'SalesmanConfig',
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        return callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };

    return {
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 搜索关键字
      searchPhone: '',
      // 对话框相关
      dialogVisible: false,
      // 表单数据
      form: {
        phone: '',
        remark: '',
      },
      // 提交按钮loading状态
      submitLoading: false,
      // 表单验证规则
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' },
        ],
        remark: [{ max: 200, message: '备注最多200个字符', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      return date.toLocaleString('zh-CN', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
    },
    // 获取业务员列表数据
    fetchData() {
      this.loading = true;

      // 过滤掉空值参数
      const params = {};
      if (this.searchPhone) {
        params.phone = this.searchPhone;
      }

      querySalesman(params)
        .then((res) => {
          this.tableData = res;
        })
        .catch((error) => {
          this.$message.error('获取业务员列表失败');
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 搜索
    handleSearch() {
      this.fetchData();
    },

    // 添加业务员
    handleAdd() {
      this.form = {
        phone: '',
        remark: '',
      };
      this.dialogVisible = true;
      // 在下一个事件循环中重置表单验证
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields();
        }
      });
    },

    // 删除业务员
    handleDelete(row) {
      this.$confirm('确认删除该业务员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (!row.userId) {
            this.$message.error('业务员ID不能为空');
            return;
          }

          deleteSalesman({ userId: row.userId })
            .then((res) => {
              if (res !== 'success') {
                this.$message.error('删除失败');
                return;
              }
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.fetchData();
            })
            .catch((error) => {
              this.$message.error('删除失败');
              console.error(error);
            });
        })
        .catch(() => {
          // 取消删除
        });
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          // 过滤掉表单中的空值
          const params = {};
          for (const key in this.form) {
            if (this.form[key] !== null && this.form[key] !== undefined && this.form[key] !== '') {
              params[key] = this.form[key];
            }
          }
          params.pwd = '';
          // 添加业务员
          addSalesman(params)
            .then((res) => {
              if (res !== 'success') {
                this.$message.error(res);
                return;
              }
              this.$message({
                type: 'success',
                message: '添加成功!',
              });
              this.dialogVisible = false;
              this.fetchData();
            })
            .catch((error) => {
              this.$message.error(error?.message);
              console.error(error);
            })
            .finally(() => {
              this.submitLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.salesman-container {
  padding: 20px;
}

.operation-area {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.search-input {
  width: 300px;
}
</style>
